const s = "af.filter-sidebar.your-fonts-filter-toggled", t = class t extends CustomEvent {
  constructor(o) {
    super(s, { detail: { filterType: o }, bubbles: !0, composed: !0 });
  }
};
t.EVENT_NAME = s;
let e = t;
export {
  s as EVENT_NAME,
  e as default
};
//# sourceMappingURL=YourFontsFilterToggleEvent.js.map
